namespace Gordic.Adm.WebControls.GAdmGlobals
{
    export enum PlatnostEnum {
        predPlatnosti,
        platne,
        poPlatnosti,
        neurceno
    }

    export enum ZamekEnum {
        uzamceno,
        neuzamceno,
    }

    export function CreateAktivitaBadge(aktivita: number): GBadgeOptions {
        var text = "";
        var color = "";
        switch (aktivita) {
            case 100:
                text = "jres:33000139";
                color = "g-state-success"
                break;
            case 300:
                text = "jres:33000142"; //RC 33000142 : Připraven
                color = "g-state-info";
                break;
            case 500:
                text = "jres:33000140";
                color = "g-state-warning";
                break;
            case 600:
                text = "jres:33000141" //RC 33000141 : Návrh
                color = "g-state-info";
                break;
            case 900:
                text = "jres:33000143" //RC 33000143 : Zrušen
                color = "g-state-error";
                break;
            default:
                text = "" //RC 33000143 : Zrušen
                color = "-"
                break;
        }
        return {
            value: text,
            customClass: color
        }
    }

    export function CreatePlatnostBadge(platnost: any): GBadgeOptions {
        var color = "";
        var text = "";
        switch (platnost) {
            case GAdmGlobals.PlatnostEnum.platne:
                color = "g-state-success";
                text = "jres:33000182" //RC 33000182 : Platné
                break;
            case GAdmGlobals.PlatnostEnum.predPlatnosti:
                color = "g-state-info";
                text = "jres:33000183" //RC 33000183 : Před platností
                break;
            case GAdmGlobals.PlatnostEnum.poPlatnosti:
                color = "g-state-warning";
                text = "jres:33000184"; //RC 33000184 : Po platnosti
        }
        return { customClass: color, value: text }
    }

    export function CreateEditaceBadge(editace: any): GBadgeOptions {
        var color = "";
        var text = "";
        if (editace == GAdmGlobals.ZamekEnum.uzamceno) {
            color = "g-state-warning"
            text = "jres:33000185" //RC 33000185 : Zakázána
        } else {
            color = "g-state-success"
            text = "jres:33000186" //RC 33000186 : Povolena
        }
        return { customClass: color, value: text }
    }

    export function CreatePlatnost(data: any): any {
        //var currentDateTime = moment();
        var currentDateTime = new Date();
        if (data.dat_od && !data.dat_do) {
            var datOd = new Date(data.dat_od);
            if (datOd > currentDateTime)
                return GAdmGlobals.PlatnostEnum.predPlatnosti;
            else
                return GAdmGlobals.PlatnostEnum.platne;
        } else if (!data.dat_od && data.dat_do) {
            var datDo = new Date(data.dat_do);
            if (datDo > currentDateTime)
                return GAdmGlobals.PlatnostEnum.platne;
            else
                return GAdmGlobals.PlatnostEnum.poPlatnosti;
        } else if (data.dat_od && data.dat_do) {
            var datOd = new Date(data.dat_od);
            var datDo = new Date(data.dat_do);
            if (datOd > currentDateTime)
                return GAdmGlobals.PlatnostEnum.predPlatnosti;
            else if (datOd < currentDateTime && datDo > currentDateTime)
                return GAdmGlobals.PlatnostEnum.platne
            else
                return GAdmGlobals.PlatnostEnum.poPlatnosti
        } else {
            return GAdmGlobals.PlatnostEnum.neurceno
        }
    }

    export function AdmContentCaptionSettings(): Gordic.Forms.Form {
        return new (Gordic.Forms.Form as any)({
            name: "admContentCaptionSettings",
            tabOptions: {
                title: "jres:33000508", //RC 33000508 : Nastavení uživatele
                opened: false
            }
        })
            .addRow("jres:33000509").addField("gcheck", {  //RC 33000509 : Zobrazovat čísla objektů
                name: "contentCaptionSetting",
                model: "Global.core.zobrazitCisloObjektu = value"
            })
    }

    export function VyberovaSkupinaDialog(typ_obj: number) {
        $.content().dialogs.showModalWindow([Gordic.Adm.WebControls.GAdmVyberovaSkupinaVyberDialog, { typ_obj: typ_obj }])
    }

    export function padLeft(number: number, length: number, character: string) {
        if (character == null) {
            character = '0';
        }
        var result = String(number);
        for (var i = result.length; i < length; ++i) {
            result = character + result;
        }
        return result;
    }
}